export interface Iprops {
  type: CalendarType;
  month?: number;
  year?: number;
  setYear?: React.Dispatch<React.SetStateAction<number>>;
  setMonth?: React.Dispatch<React.SetStateAction<number>>;
}

export enum CalendarType {
  month,
  year,
  girdle,
}
